/* 🤖 this file was generated by svg-to-ts */
export const iconLend: {
  name: 'lend';
  data: string;
} = {
  name: 'lend',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#aave[old]__clip0_297_20)"><path fill="currentColor" d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0m-5.08 27.607-1.96-1.96 4.587-4.587-4.587-4.588 1.96-1.96 6.537 6.537-6.537 6.538zm7.379-7.368L11.76 13.7l1.95-1.95 6.538 6.538zm4.741-4.732-1.96 1.96-6.537-6.537 6.537-6.537 1.96 1.96-4.587 4.587 4.587 4.588z"/></g><defs><clipPath id="aave[old]__clip0_297_20"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
